import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';
import { CustomersRoutingModule } from './customers.routing';
import { CustomerListComponent } from './components/list/customers-list.component';
import { CustomerFormComponent } from './components/new/customer-form.component';
import { CustomersListPageComponent } from './pages/list/customers-list-page.component';
import { CustomerDetailPageComponent } from './pages/detail/customer-detail-page.component';
import { NewCustomerPageComponent } from './pages/new/new-customer.component';
import { EditCustomerPageComponent } from './pages/edit/edit-customer.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, TranslateModule, CustomersRoutingModule],
  declarations: [
    CustomerListComponent,
    CustomerFormComponent,
    CustomersListPageComponent,
    CustomerDetailPageComponent,
    NewCustomerPageComponent,
    EditCustomerPageComponent
  ]
})
export class CustomersModule {}
